const es = {
  // Navegación
  nav: {
    home: 'Inicio',
    about: 'Sobre Mí',
    experience: 'Experiencia',
    projects: 'Proyectos',
    contact: 'Contacto',
  },

  // Sección Hero
  hero: {
    greeting: 'Especialista en Ciberseguridad',
    titles: ['Especialista en Ciberseguridad', 'Analista SOC Nivel 1', 'Entusiasta del Hacking Ético'],
    description: 'Automatización de seguridad, monitoreo de amenazas y defensa para sistemas modernos.',
    viewProjects: 'Ver Proyectos',
    downloadCV: 'Descargar CV',
  },

  // Sección Sobre Mí
  about: {
    title: 'Sobre Mí',
    description: 'Me llamo Diogo Cunha, tengo 24 años y soy militar de la Fuerza Aérea Portuguesa. Soy especialista en ciberseguridad con más de 3 años en operaciones de defensa, enfocado en monitoreo, threat hunting y automatización de seguridad. Tengo una sólida experiencia en desarrollo con Python y seguridad de redes, construyendo sistemas resilientes y herramientas prácticas. Empecé en este campo por mi gran interés en la tecnología, lo que me llevó a seguir el camino de la ciberseguridad. Mi objetivo es adquirir el máximo conocimiento posible y crecer tanto profesional como personalmente.',
    stats: {
      experience: 'Años de Experiencia',
      certifications: 'Certificaciones',
      projects: 'Proyectos de Seguridad',
    },
    highlightsTitle: 'Lo Que Ofrezco',
    highlights: {
      securityOps: {
        title: 'Operaciones de Seguridad',
        description: 'Trabajo práctico de defensa en monitoreo, investigación y respuesta a incidentes con mentalidad basada en riesgo.',
      },
      threatAnalysis: {
        title: 'Análisis de Amenazas y Malware',
        description: 'Triaje y análisis para comprender comportamientos, reducir exposición y mejorar playbooks de detección y respuesta.',
      },
      automation: {
        title: 'Automatización y Herramientas',
        description: 'Construcción de herramientas prácticas que simplifican trabajo repetitivo y transforman insights de seguridad en workflows repetibles.',
      },
    },
  },

  // Sección Experiencia
  experience: {
    title: 'Experiencia',
    subtitle: 'Mi trayectoria en la industria de ciberseguridad y TI',
    tabs: {
      professional: 'Profesional',
      academic: 'Académico',
      certifications: 'Certificaciones',
    },
    jobs: {
      cybersecuritySpecialist: {
        title: 'Especialista en Ciberseguridad',
        company: 'Portuguese Air Force',
        responsibilities: [
          'Análisis y Detección de Malware',
          'Evaluación de Vulnerabilidades',
          'Automatización y scripting en Python',
          'Penetration Testing',
          'Sistemas operativos y fundamentos de redes',
        ],
      },
      complianceAnalyst: {
        title: 'Especialista de Compliance',
        company: 'Leica Microsystems',
        responsibilities: [
          'Gestión de sistemas SAP',
          'Análisis de datos en Excel',
          'Informes y documentación de compliance',
        ],
      },
      itConsultant: {
        title: 'Consultor de TI',
        company: 'Inetum',
        responsibilities: [
          'Soporte y consultoría al cliente',
          'Integración de sistemas',
        ],
      },
      itTechnician: {
        title: 'Técnico de TI',
        company: 'Claranet',
        responsibilities: [
          'Instalación de Equipos TI',
          'Preparación de equipos para instalación',
          'Configuración de IP en Impresoras',
          'Configuración y puesta a punto de computadoras en red',
        ],
      },
    },
    education: {
      cybersecurity: {
        degree: 'Ciberseguridad',
        institution: 'ISTEC',
        level: 'Técnico Nivel 5',
        description: 'Estudios avanzados en ciberseguridad, enfocando en penetration testing, defensa de red y arquitectura de sistemas seguros.',
      },
      programming: {
        degree: 'Gestión y Programación de Sistemas Informáticos',
        institution: 'Escola Secundária Leal da Câmara',
        level: 'Cualificación Nivel 4',
        description: 'Fundamentos en sistemas informáticos, programación y gestión de TI.',
      },
    },
    certifications: [
      { name: 'Cyber Defender Final Examination', issuer: 'MILE2', year: '2024' },
      { name: 'C)ITP: Certified Information Technology Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)SP: Certified Security Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)NP: Certified Network Principles', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-NSD: Network Security and Defense', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-IRM: Incident Response and Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-TIVM: Threat Intelligence and Vulnerability Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-FOC: Foundations of Cybersecurity', issuer: 'MILE2', year: '2024' },
      { name: 'Ethical Hacking Essentials (EHE)', issuer: 'EC-Council', year: '2022' },
      { name: 'Digital Forensics Essentials (DFE)', issuer: 'EC-Council', year: '2023' },
    ],
  },

  // Sección Proyectos
  projects: {
    title: 'Proyectos Destacados',
    subtitle: 'Herramientas de seguridad, automatización y trabajo de ingeniería seleccionados.',
    featured: 'Destacado',
    items: {
      blueTeam: {
        title: 'Scripts de Defensa Blue Team',
        description: 'Colección de scripts Python diseñados para monitoreo y operaciones de defensa en ciberseguridad. Herramientas automatizadas para detección de amenazas, análisis de logs y respuesta a incidentes en operaciones blue team.',
        overlay: 'Defensa Blue Team',
      },
      carapauCracker: {
        title: 'CarapauCracker - Herramienta de Análisis de Seguridad',
        description: 'Framework avanzado de análisis y pruebas de seguridad basado en Python. Desarrollado para penetration testing y evaluación de vulnerabilidades con capacidades de shell scripting automatizado.',
        overlay: 'Análisis de Seguridad',
      },
      writeUpPage: {
        title: 'Write-Up Page',
        description: 'Página dedicada a organizar y publicar write-ups de seguridad, retos y análisis técnicos. Diseñada para presentar el contenido de forma clara, estructurada y fácil de consultar.',
        overlay: 'Write-Ups',
      },
      sportsAnalysis: {
        title: 'Análisis Deportivo',
        description: 'Una plataforma inspirada en Flashscore, pero centrada en análisis más profundos para trading deportivo — estadísticas detalladas y probabilidades de resultado para cada partido.',
        overlay: 'Análisis Deportivo',
      },
    },
  },

  // Sección Contacto
  contact: {
    title: 'Ponte en Contacto',
    subtitle: 'Abierto a proyectos, colaboraciones y roles de seguridad.',
    infoTitle: '¡Hablemos!',
    infoText: 'Comparte una breve descripción y timeline, y responderé lo antes posible.',
    email: 'Email',
    location: 'Ubicación',
    locationValue: 'Lisboa / Portugal',
    form: {
      name: 'Nombre',
      namePlaceholder: 'Tu nombre',
      email: 'Email',
      emailPlaceholder: 'Tu email',
      message: 'Mensaje',
      messagePlaceholder: 'Tu mensaje',
      submit: 'Enviar Mensaje',
      success: '¡Mensaje enviado con éxito! Gracias por contactar.',
      errors: {
        nameRequired: 'Por favor introduce tu nombre',
        emailRequired: 'Por favor introduce tu email',
        emailInvalid: 'Por favor introduce un email válido',
        messageRequired: 'Por favor introduce un mensaje',
      },
    },
  },

  // Pie de página
  footer: {
    builtWith: 'Construido con React | Portafolio de Ciberseguridad',
    role: 'Especialista en Ciberseguridad | Desarrollador Full Stack',
  },
};

export default es;
